import React, { useState } from 'react';

import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Box, Button, IconButton, Menu, MenuItem, Typography } from '@mui/material';

import { ReminderPublisher } from '@europrocurement/l2d-domain';

import useSendMailReminderPublisher from '../detail/PublisherReminder/hooks/useSendMailReminderPublisher';
import useDeleteReminderPublisher from '../detail/PublisherReminder/hooks/useDeleteReminderPublisher';
import useConsultReminderPublisher from '../detail/PublisherReminder/hooks/useConsultReminderPublisher';

export type PublishersRemindersActionMenuType = {
    reminderPublisher: ReminderPublisher;
};

const PublishersRemindersActionMenu: React.FunctionComponent<PublishersRemindersActionMenuType> =
    function ({ reminderPublisher }) {
        const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
        const open = Boolean(anchorEl);
        const handleClick = (event: React.MouseEvent<HTMLElement>) => {
            setAnchorEl(event.currentTarget);
        };
        const handleClose = () => {
            setAnchorEl(null);
        };

        const { consultReminderPublisher } = useConsultReminderPublisher();
        const { deleteReminderPublisher } = useDeleteReminderPublisher({ from: 'list' });
        const { sendMailReminderPublisher } = useSendMailReminderPublisher({ from: 'list' });

        return (
            <Box
                onClick={(e) => {
                    e.stopPropagation();
                }}
            >
                <IconButton
                    aria-label="more"
                    id="long-button"
                    aria-controls={open ? 'long-menu' : undefined}
                    aria-expanded={open ? 'true' : undefined}
                    aria-haspopup="true"
                    onClick={handleClick}
                >
                    <MoreVertIcon />
                </IconButton>
                <Menu
                    id="long-menu"
                    MenuListProps={{
                        'aria-labelledby': 'long-button',
                    }}
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                >
                    {reminderPublisher.id ? (
                        <MenuItem onClick={handleClose}>
                            <Button
                                onClick={() => {
                                    consultReminderPublisher(reminderPublisher);
                                }}
                                style={{ textDecoration: 'none', padding: '0' }}
                                size="small"
                            >
                                <Typography sx={{ color: 'text.primary' }}>
                                    Consulter le rappel
                                </Typography>
                            </Button>
                        </MenuItem>
                    ) : (
                        <MenuItem>Erreur, rappel manquant</MenuItem>
                    )}
                    {reminderPublisher.id ? (
                        <MenuItem
                            onClick={() => {
                                deleteReminderPublisher(reminderPublisher);
                                handleClose();
                            }}
                        >
                            <Typography sx={{ color: 'text.primary' }}>
                                Supprimer le rappel
                            </Typography>
                        </MenuItem>
                    ) : (
                        <MenuItem>Erreur, rappel manquant</MenuItem>
                    )}
                    {reminderPublisher.id ? (
                        <MenuItem
                            onClick={() => {
                                sendMailReminderPublisher(reminderPublisher);
                                handleClose();
                            }}
                        >
                            <Typography sx={{ color: 'text.primary' }}>Envoyer le mail</Typography>
                        </MenuItem>
                    ) : (
                        <MenuItem>Erreur, rappel manquant</MenuItem>
                    )}
                </Menu>
            </Box>
        );
    };

export default PublishersRemindersActionMenu;
